<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, index) in slices"
      :key="index"
      :slice="slice"
    />
  </div>
</template>

<script>
import {
  Hero,
  HighlightSection,
  TrustpilotCarousel,
  FaqSlice,
  CustomerService,
} from '@@/shared-slices'

import { ArticleSlice } from '~/components/slices'

export default {
  name: 'ProductsHubModule',
  components: {
    hero: Hero,
    highlight_section: HighlightSection,
    trustpilot_carousel: TrustpilotCarousel,
    faq_slice: FaqSlice,
    article_anchor: ArticleSlice,
    customer_service: CustomerService,
  },
  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      slices: this.moduleData.data.body,
    }
  },
}
</script>
